import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


function getParamCaseInsensitive(params: URLSearchParams, key: string): string | null {
    const lowerCaseKey = key.toLowerCase();
    var result = null;
    params.forEach((value, name) => {
        if (name.toLowerCase() === lowerCaseKey) {
            result = value;
        }
    });

    return result;
}

export { useWindowDimensions, getParamCaseInsensitive };